import { EducationalHighlightSortFields, SortDirection, useEducationalhighlightsQuery } from "../generated/graphql"
import { staticFile } from "../services/Utils"

export default function useEducationalHighlights() {

    const { data, loading, error } = useEducationalhighlightsQuery({
        variables: {
            filter: { isActive: { is: true } },
            paging: { limit: 2 },
            sorting: [
                {
                    field: EducationalHighlightSortFields.Order,
                    direction: SortDirection.Asc
                }]
        }
    })

    const sorted = data?.educationalHighlights?.nodes
        ?.slice()
        .sort((a, b) => (a.order ?? 0) - (b.order ?? 0)) || []


    const educationalHighlights = sorted.map(highlight => {
        highlight.image = staticFile(highlight.image)
        return highlight
    }
    )

    return {
        educationalHighlights, loading, error
    }
}
